import { OverlayRef } from '@angular/cdk/overlay';
import { TemplateRef, Type } from '@angular/core';
import { Subject } from 'rxjs';

export interface OverlayCloseEvent<R> {
    type: 'close',
    data: R
}

export class DialogOverlayRef<R=any, T=any> {
    afterClosed$ = new Subject<OverlayCloseEvent<R>>();

    constructor(
        private overlayRef: OverlayRef, 
        public content: string | TemplateRef<any> | Type<any>, 
        public config: T
    ) {
        this.afterClosed$.subscribe(() => {
            this.overlayRef.dispose();
        });
    }

    private _close(type: 'close', data: R) {
        this.afterClosed$.next({
            type, 
            data
        });

        this.afterClosed$.complete();
    }

    close(data?: R) {
        this._close('close', data);
    }
}